import React, { useContext, useState, useEffect, useReducer } from "react";

const OoklaTests = (props) => {
  return (
    <div className='text-center mt-3 w-100'>
      <div className='text-center' id='speed-test' style={{ width: "510px", height: "660px" }}></div>
    </div>
  );
};
export default OoklaTests;
